import isNil from 'lodash/isNil'

import { TickerActionType } from './actions'
import * as AT from './actionTypes'
import { TickerType } from './types'

export type TickerStateType = {
  [symbol: string]: TickerType & {
    readonly subscribed: boolean
  }
}

const initialState = {}

const ticker = (
  state: TickerStateType = initialState,
  action: TickerActionType
): TickerStateType => {
  switch (action.type) {
    case AT.RESET: {
      return {
        ...state,
        [action.payload.symbol]: {
          ...state[action.payload.symbol],
          subscribed: false
        }
      }
    }

    case AT.SET_SUBSCRIBED: {
      const data = state[action.payload.symbol] || {}
      return {
        ...state,
        [action.payload.symbol]: {
          ...data,
          subscribed: true
        }
      }
    }

    case AT.SET_UPDATE: {
      const data = state[action.payload.symbol] || {}

      const { ticker } = action.payload

      Object.entries(ticker).forEach(([key, value]) => {
        if (isNil(value)) {
          return
        }

        data[key] = value
      })

      return {
        ...state,
        [action.payload.symbol]: data
      }
    }

    default:
      return state
  }
}

export default ticker
